import { useId, useLayoutEffect, useRef, useState } from "react";
import "./faq-motion.css";

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const content = useRef(null);
  const id = useId();
  useLayoutEffect(() => {
    const element = content.current;
    const measure = () => setHeight(element.getBoundingClientRect().height);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return (
    <div className="faq-item" data-open={open}>
      <h3 className="faq-question">
        <button id={`${id}-question`} type="button" aria-expanded={open} aria-controls={`${id}-answer`} onClick={() => setOpen(value => !value)}>
          <span className="faq-arrow" aria-hidden="true" />{question}
        </button>
      </h3>
      <div id={`${id}-answer`} className="faq-answer" aria-labelledby={`${id}-question`} aria-hidden={!open}
        inert={open ? undefined : ""} style={{ height: open ? height : 0 }}>
        <div ref={content} className="faq-answer-inner"><p>{answer}</p></div>
      </div>
    </div>
  );
};

export const FAQSection = () => <section id="faq"><div className="fokeev-faq">
  <h2>Перед началом обучения</h2>
  {[
    ["Где я буду проходить курс?", "После оплаты на указанную почту придёт приглашение в Skillspace. Там находятся уроки и материалы. Кнопка «Мои курсы» в меню открывает платформу обучения."],
    ["Нужно ли заниматься по расписанию?", "Вы смотрите записанные уроки в своём темпе. Условия и состав программы указаны на странице выбранного курса."],
    ["Как выбрать курс с проверкой заданий?", "Смотрите название и описание тарифа. Например, у Figma Pro есть самостоятельный курс и отдельный вариант с проверкой домашних заданий автором."],
    ["Что делать, если письмо не пришло?", "Проверьте папку «Спам» и почту, указанную при покупке. Если приглашения нет, напишите на hello@dmitrii-fokeev.ru и укажите название курса и почту заказа."],
    ["Можно ли вернуть оплату?", "На сайте действует гарантия возврата в течение 30 дней. Подробные условия приведены в публичной оферте; для обращения напишите на hello@dmitrii-fokeev.ru."]
  ].map(([q,a]) => <FAQItem key={q} question={q} answer={a} />)}
</div></section>;
